import React from 'react';
import PropTypes from 'prop-types';
import { IoCheckmarkOutline } from "@react-icons/all-files/io5/IoCheckmarkOutline";
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";


const MaterialIconList = ({ icon, items }) => {
  return (
    <div className="dui-grid dui-grid-cols-2 dui-gap-4">
      {items.map((item, i) => (
        <div key={i} className="dui-flex dui-gap-2 dui-items-center">
          {icon.name === 'clear' ? (
            <RxCross1 className="dui-shrink-0" />
          ) : (
            <IoCheckmarkOutline className="dui-shrink-0" />
          )}
          <span className="">
            {typeof item === 'function' ? item() : item}
          </span>
        </div>
      ))}
    </div>
  );
};

MaterialIconList.propTypes = {
  icon: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired
};

export default MaterialIconList;
